module.exports = __webpack_public_path__ + "img/logo-new-idi.04dc8bc2.png";